/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorSavedArticles from 'base/components/labrador/SavedArticles';

export const DynamicLabradorSavedArticles: typeof LabradorSavedArticles = (props) => {
    return <ErrorBoundary><LabradorSavedArticles {...props} /></ErrorBoundary>;
}
export type DynamicLabradorSavedArticlesProps = PropsFromComponent<typeof LabradorSavedArticles>;
